module.exports = __webpack_public_path__ + "bef441ee9b180dcc293ffcd25eab2607.svg";